module.exports = __webpack_public_path__ + "portal-static/img/9.88fc500c.jpg";